import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=2baa6766&scoped=true"
import script from "./activityDetails.vue?vue&type=script&lang=js"
export * from "./activityDetails.vue?vue&type=script&lang=js"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=2baa6766&prod&lang=scss&scoped=true"
import style1 from "./activityDetails.vue?vue&type=style&index=1&id=2baa6766&prod&lang=css"
import style2 from "./activityDetails.vue?vue&type=style&index=2&id=2baa6766&prod&lang=scss&scoped=true"
import style3 from "./activityDetails.vue?vue&type=style&index=3&id=2baa6766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa6766",
  null
  
)

export default component.exports